/*
 * fn: fetchMoreCombos
 *
 * Fetches a page worth of Combo Preview data
 *
 */
import { type MoreCombosResponse } from '@/defs/apiLegacy/pagePartsResponse'
import { type ComboPreviewType } from '@/defs/combo'
import { type RouteType } from '@/defs/route'
import { filterCombos, parseComboPreviewResponse } from '@/utils/comboUtil'
import { fetchApi } from '@/utils/requestUtil'

type Props = {
  more: string
  route?: RouteType
}

export const fetchMoreCombos = async ({ more, route }: Props) => {
  const response = await fetchApi<MoreCombosResponse>({ base: 'jsonCloudflare', path: `/pages/${more}` })
  const moreResponse = response.data.more
  const combos = filterCombos({
    combos: (response.data.cardlists || [])
      .map((cardList) => {
        const combo = parseComboPreviewResponse({ cardList })
        if (combo === false)
          console.error(`[apiUtil/fetchMoreCombos] Error parsing combo with header ${cardList.header}, skipping.`)
        return combo
      })
      .filter((c): c is ComboPreviewType => c !== false),
    route,
  })

  return { combos, more: moreResponse }
}
